import { t } from "i18next"

export const PAGE_SIZE = 10;

// 社交登录类型枚举
export enum SocialLoginType {
  // 邮箱注册
  EMAIL = 0,
  // 手机号注册
  PHONE = 1,
  // Google登录
  GOOGLE = 10,
  // Google APP登录
  GOOGLE_APP = 15,
  // Google IOS登录
  GOOGLE_APP_IOS = 18,
  // Facebook登录
  FACEBOOK = 20,
  // Apple登录
  APPLE = 30,
  // Apple登录app端
  APPLE_APP = 31,
  // Line登录
  LINE = 40,
  // Line移动应用登录
  LINE_MOBILE = 41,
  // 微信公众号登录
  WXMP = 50,
  // 微信小程序登录
  WXMA = 60,
  // 微信开放平台移动应用
  WXOPEN_MOBILE = 70,
}

export interface ILanguageCode {
  name: string;
  code: string;
}
/**
 * @description 支持的语言列表
 * @requires 新增语言需要同步修改一下 TextInputBox | AiSummaryModal 组件中的语言切换逻辑
 */
export const languagesCodes = [
  { name: "简体中文", code: "zh-CN" },
  { name: "English", code: "en-US" },
  { name: "ภาษาไทย", code: "th-TH" },
];

export type LanguageCode = "zh-CN" | "en-US" |"th-TH";
                          
export const languagesCodeMap: Record<string, LanguageCode> = {
  ...Object.fromEntries(
    languagesCodes.map(({ code }) => [code, code as LanguageCode])
  ) as Record<string, LanguageCode>,
  // 这里加上常用语言代码映射
  "zh": "zh-CN",
  "en": "en-US",
  "th": "th-TH",
};

export const languagesTextMap: Record<LanguageCode, string> = {
  "zh-CN": "简体中文",
  "en-US": "English",
  "th-TH": "ภาษาไทย",
};

export interface IPathObject {
  router: string;
  [key: string]: string | number | undefined;
}

export enum RichTextTypeEnum {
  TEXT = 1,
  BIG_IMAGE = 2,
  SMALL_IMAGE = 3,
}
export const getRichTextTypeTextMap = () => ({
  [RichTextTypeEnum.TEXT]: t("文字"),
  [RichTextTypeEnum.BIG_IMAGE]: t("大图"),
  [RichTextTypeEnum.SMALL_IMAGE]: t("小图"),
})
export const RichTextTypeIconMap = {
  [RichTextTypeEnum.TEXT]: '/ss/app/image/privateMvp/text02.svg',
  [RichTextTypeEnum.BIG_IMAGE]: '/ss/app/image/privateMvp/img05.svg',
  [RichTextTypeEnum.SMALL_IMAGE]: '/ss/app/image/privateMvp/img06.svg',
}

export interface IRichTextItem {
  id: string;
  type: RichTextTypeEnum;
  content: string;
  images?: string[];
  isLoading?: boolean;
}

///订单状态：10-初始化，20-支付中，30-已支付
export enum OrderStatusEnum {
  INITIALIZED = 10, // 初始化
  PAYING = 20, // 支付中
  WAITING_CONFIRMATION = 25, // 待确认支付
  PAID = 30, // 已支付
}
export const getOrderStatusTextMap = () => ({
  [OrderStatusEnum.INITIALIZED]: t("初始化"),
  [OrderStatusEnum.WAITING_CONFIRMATION]: t("待确认支付"),
  [OrderStatusEnum.PAYING]: t("支付中"),
  [OrderStatusEnum.PAID]: t("已支付"),
})


///发货状态：10-待发货，20-已发货，30-已签收
export enum ShipStatusEnum {
  PENDING = 10, // 待发货
  SHIPPED = 20, // 已发货
  SIGNED = 30, // 已签收
}

export const getShipStatusTextMap = () => ({
  [ShipStatusEnum.PENDING]: t("待发货"),
  [ShipStatusEnum.SHIPPED]: t("已发货"),
  [ShipStatusEnum.SIGNED]: t("已签收"),
})

export const ShipStatusIconMap = {
  [ShipStatusEnum.PENDING]: '/ss/app/image/privateMvp/fast-status02.png',
  [ShipStatusEnum.SHIPPED]: '/ss/app/image/privateMvp/fast-status03.png',
  [ShipStatusEnum.SIGNED]: '/ss/app/image/privateMvp/fast-status05.png',
}

export enum DeliveryTypeEnum {
  CHINESE = 10, // 中国发货(跨境)
  THAILAND = 20, // 泰国本地发货
  MIXED = 30, // 部分泰国/部分中国
}

// 发货时效：24小时/48小时/72小时内发货/7天内发货
export enum DeliveryTimeEnum {
  HOUR_24 = 24, // 24小时内发货
  HOUR_48 = 48, // 48小时内发货
  HOUR_72 = 72, // 72小时内发货
  DAY_7 = 7, // 7天内发货
}

///主页类型：10-供货商，20-普通团长主页
export enum GhTypeEnum {
  SUPPLIER = 10, // 供货商
  SELLER = 20, // 普通团长主页
  PROFILE = 5, // 个人主页
}

export const getGhTypeEnumTextMap = () => ({
  [GhTypeEnum.SUPPLIER]: t("供货商主页"),
  [GhTypeEnum.SELLER]: t("团长主页"),
  [GhTypeEnum.PROFILE]: t("个人主页"),
})

/// 上传文件作用域
export enum ScopeEnum {
  PUBLIC = "public", // 公共
  PRIVATE = "private", // 私有
}

export enum PublicStatusEnum {
  UNPUBLISHED = 5, // 未发布
  PUBLISHED = 10, // 已发布
}

export const getPublicStatusTextMap = () => ({
  [PublicStatusEnum.UNPUBLISHED]: t("未发布"),
  [PublicStatusEnum.PUBLISHED]: t("已发布"),
})

export enum DefaultTypeEnum {
  NO = 0, // 否
  YES = 1, // 是
}

export enum ActivityTypeEnum {
    /**
     * 供货母团
     */
    SUPPLIER_GROUP = 10, // 供货母团

    /**
     * 帮卖子团
     */
    SELLER_GROUP = 20, // 帮卖子团

    /**
     * 团购接龙
     */
    GROUP_BUY = 30, // 团购接龙
}

//活动状态
export enum ActStatusEnum {
  PENDING = 10, // 未开始
  STARTED = 20, // 进行中
  ENDED = 30, // 已结束
}

export const getActStatusTextMap = () => ({
  [ActStatusEnum.PENDING]: t("未开始"),
  [ActStatusEnum.STARTED]: t("正在接龙"),
  [ActStatusEnum.ENDED]: t("已结束"),
})

///增加类型:10 收入 20 支出，不传则查全部
export enum IncDecTypeEnum {
  INCOME = 10, // 收入
  EXPENDITURE = 20, // 支出
}

export const getIncDecTypeEnumTextMap = () => ({
  [IncDecTypeEnum.INCOME]: t("收入"),
  [IncDecTypeEnum.EXPENDITURE]: t("支出"),
})

export enum WithdrawStatusEnum {
  ING = 'ING', // 进行中
  FAIL = 'FAIL', // 失败
  SUCCESS = 'SUCCESS', // 成功
  GREEN = 'GREEN', // 绿图标
  GRAY = 'GRAY', // 灰色图标
  CANCEL = 'CANCEL', // 取消图标
}

export enum WithdrawStatusImageEnum {
    ING = "/ss/app/image/privateMvp/time01.png", // 进行中
    FAIL = "/ss/app/image/privateMvp/warn02.png", // 失败
    SUCCESS = "/ss/app/image/privateMvp/select06.png", // 成功
    GREEN = "GREEN", // 绿图标
    GRAY = "GRAY", // 灰色图标
    CANCEL = "CANCEL", // 取消图标
}

// commentStatus?: number, // 状态：10-待审核，20-已通过，30-已拒绝
export enum EvaluationStatusEnum {
  PENDING = 10, // 待审核
  APPROVED = 20, // 已通过
  REJECTED = 30, // 已拒绝
}

export const getEvaluationStatusTextMap = () => ({
  [EvaluationStatusEnum.PENDING]: t("待审核"),
  [EvaluationStatusEnum.APPROVED]: t("已采纳"),
  [EvaluationStatusEnum.REJECTED]: t("不采纳"),
})


export enum StarStatusEnum {
  INVALID = 0, // 无效（取消点赞）
  VALID = 1, // 有效（点赞）
}

export enum RefundOrderStatusEnum {
  COMPANY_REFUSE = 5, // 审批拒绝
  INIT = 10, // 新建退款订单/团长审核中
  COMPANY_VERIFY = 30, // 审批通过
  BALANCE_LACKING = 40, // 团长订单余额不足
  OPT_EXCEPTION = 50, // 其他原因退款失败
  SYS_AGREE = 60, // 系统受理
  THIRD_PAY_START = 220, // 支付网关处理
  JP_GY_ACCEPTING = 230, // 第三方网关退款受理接受成功
  SUCCESS = 300, // 第三方网关退款受理业务成功
  JP_GY_ACCEPT_FAILED = 310, // 第三方网关退款受理接受失败
  GATE_WAY_FAILED = 311, // 网关失败
  FAIL_RETRY_ONCE = 401, // 内部平账，失败重试第一次
  FAIL_RETRY_TWICE = 402, // 内部平账，失败重试第二次
  JP_GY_FAILED = 320, // 第三方网关退款受理业务失败
  REFUND_FAIL_DEALED = 330, // 网关失败，系统管理员已将资金退回给发起人
}

// 售后状态枚举
export enum RefundAuditStatusEnum {
  WAIT_AUDIT = 10, // 待审核
  APPROVED = 20, // 审核通过
  REJECTED = 30, // 审核拒绝
}

export const getRefundAuditStatusEnumTextMap = () => ({
  [RefundAuditStatusEnum.WAIT_AUDIT]: t('退款，待团长处理'),
  [RefundAuditStatusEnum.APPROVED]: t("退款，售后成功"),
  [RefundAuditStatusEnum.REJECTED]: t("退款，售后拒绝"),
})